module.exports = __webpack_public_path__ + "static/img/i_btn_use.6f515efb.png";